<template>
  <div class="Questions">
    <div class="container">
      <Topics />
      <Dashboard />
      <QuestionsList />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Topics from './Topics';
import Dashboard from './Dashboard';
import QuestionsList from './QuestionsList';

export default {
  name: 'Questions',
  components: {
    Topics,
    Dashboard,
    QuestionsList,
  },
  async created() {
    await this.fetchQuestions();
  },
  methods: {
    ...mapActions(['fetchQuestions']),
  },
  computed: {
    ...mapGetters(['getCurrentTopic', 'getQuestions']),
  },
};
</script>

<style lang="scss" scoped>
.Questions {
  margin-bottom: 150px;
  padding: 50px 0;
  background-color: $color-white;
  .container {
    position: relative;
    z-index: 1;
    min-height: 1000px;
    padding: 50px 150px 80px;
    margin-top: -170px;
    border-radius: 45px;
    background: $color-white;
    box-shadow: 0 2px 25px 0 rgba(0, 0, 0, 0.1);
  }
}

@media screen and (max-width: 1200px) {
  .Questions {
    .container {
      padding: 50px 30px 80px;
    }
  }
}

@media screen and (max-width: 650px) {
  .Questions {
    .container {
      padding: 12px 12px 22px;
      border-radius: 32px;
    }
  }
}
</style>
